import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getDetailLivraisonCommande
} from "../../Redux/livraisonReduce";
import Configuration from "../../configuration";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
function DetailsLivraisonCalend({client}) {
  const dispatch = useDispatch();
  const location = useParams();
  var idLivraison = location.id_livraison;
  var numCmd = location.numCmd;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [livraison, setLivraison] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailLivraison */
  const detailLivraison = useCallback(async (idLivraison, numCmd) => {
    var det = await dispatch(getDetailLivraisonCommande({ idLivraison, numCmd }));
    var dataD = await det.payload;
    setData(dataD)
    setLoader(false)
  }, [dispatch, idLivraison]);




  useEffect(() => {
    detailLivraison(idLivraison, numCmd)
  }, [idLivraison]);



  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">Détails {numCmd}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("No_livraison")}</th>
                              <th>Code {t("Wholesaler")}</th>
                              <th>{t("Wholesaler")}</th>
                              <th>{t("date_liv")}</th>
                              <th>{t("No_commande")}</th>
                              <th>{t("code_article")}</th>
                              <th>{t("designation")}</th>
                              <th>{t("qte")}</th>
                              <th>{t("Lot")}</th>
                              <th>{t("Date expiration")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.length > 0 && data.map((e) => {
                              return (
                                <tr key={"ligne-" + e.id}>
                                  <td>{e.No_livraison}</td>
                                  <td>{e.livraisons.Client_commande}</td>
                                  <td>{e.livraisons?.grossistes?.Raison_sociale}</td>
                                  <td>{e.Date_expedition}</td>
                                  <td>{e.No_commande}</td>
                                  <td>{e.Code_article}</td>
                                  <td>{e.Designation_article}</td>
                                  <td>{e.Qte}</td>
                                  <td>
                                    {e.Lot
                                      ? e.Lot.toUpperCase().includes("ST")
                                        ? e.Lot
                                        : client === "/medis"
                                          ? e.Lot.substring(6)
                                          : e.Lot.slice(0, -5)
                                      : ""}
                                  </td>

                                  <td>{e.Date_expiration}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsLivraisonCalend;
